import type { TeaserCardSelectPayload } from "../core/types";

export type ToTeaserCardPayloadOptions = {
  location?: string;
  dataCypress?: string;
};

export function toTeaserCardPayload(
  item?: any,
  options?: ToTeaserCardPayloadOptions
): TeaserCardSelectPayload {
  const content_label = item?.teaserTitle as string | undefined;
  const teasercard_location = options?.location ?? options?.dataCypress;

  return {
    content_label,
    teasercard_location,
  };
}
